/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyArrayType } from '../../models/key-array-type';
import { KeyType } from '../../models/key-type';
import { PostBundleResponse } from '../../models/post-bundle-response';

export interface PostMergeBundles$Params {
  organizationSiteKey: KeyType;
      body: KeyArrayType
}

export function postMergeBundles(http: HttpClient, rootUrl: string, params: PostMergeBundles$Params, context?: HttpContext): Observable<StrictHttpResponse<PostBundleResponse>> {
  const rb = new RequestBuilder(rootUrl, postMergeBundles.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PostBundleResponse>;
    })
  );
}

postMergeBundles.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles-merge';
